import {getChatConfig} from '@peoplenet/tfm-shared/chat/config'
import {getEldConfig} from '@peoplenet/tfm-shared/eldUi/config'
import {getMioeConfig} from './supportCases/config'
import {getIntegrationsConfigurationConfig} from './integrationsConfiguration/config'
import {getUpsUiConfig} from './upsUi/config'
import {getOrgManagementConfig} from '@peoplenet/tfm-shared/orgManagement/config'
import {getRemoteLogoutConfig} from '@peoplenet/tfm-shared/remoteLogout/config'
import {getOEMConfig} from '@peoplenet/tfm-shared/oemGateways/config'
import {getEntitySyncConfig} from './entitySync/config'
import {getNewsFeedConfig} from '@peoplenet/tfm-shared/newsFeed/config'
import {getEnvironmentConfig} from './dvir/config'
import {getPSConfig} from '@peoplenet/tfm-shared/psEld/psConfig'

window.chatEnvUrl = getChatConfig()
window.eldEnvUrl = getEldConfig()
window.mioeEnvUrl = getMioeConfig()
window.integrationsConfigurationEnvUrl = getIntegrationsConfigurationConfig()
window.orgManagementUrl = getOrgManagementConfig()
window.entitySyncEnvUrl = getEntitySyncConfig()
window.remoteLogoutEnvUrl = getRemoteLogoutConfig()
window.oemEnvUrl = getOEMConfig()
window.newsFeedEnvUrl = getNewsFeedConfig()
window.dvirEnvUrl = getEnvironmentConfig()
window.upsEnvUrl = getUpsUiConfig()
window.psEnvUrl = getPSConfig()

import('./bootstrap')
